import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import { Icon, Stack, } from '../../index.js';
import styles from './list.module.css';
const sizes = {
    small: {
        icon: {
            size: 16,
        },
    },
    regular: {
        icon: {
            size: 16,
        },
    },
    big: {
        icon: {
            size: 24,
        },
    },
};
export const Li = forwardRef(({ className, hideMarker, marker = 'circle', markerColor, children, dimension = 'regular', ...otherProps }, forwardedRef) => (_jsxs(Stack, { className: clsx(styles.ListItem, className), as: "li", value: "00", direction: "row", hAlign: "start", vAlign: "start", fill: false, ref: forwardedRef, ...otherProps, children: [hideMarker ? null : (_jsx(Icon, { source: marker, className: styles.Marker, fill: markerColor, "data-list-default-marker": marker === 'circle', dimension: marker === 'circle' ? 12 : sizes[dimension].icon.size })), children] })));
